import styled from 'styled-components'
import {
	danger,
	black,
	textMuted,
	mutedGrey,
	white,
	grey,
	pdfBadgeBg,
	pdfBadgeFg,
	scrimDark,
} from '@/theme/colors'
import { media, layers } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'
import { innerCardSurface, tintOnHover } from '@components/Card'




export const UploadButton = styled(Button)``

export const FileGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 16px;

	${media.phone} {
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}

	${media.aboveTablet} {
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	}

	${media.wide} {
		grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	}
`

/** The whole card opens the file, so its tint deepens on hover. */
export const FileCard = styled.div`
	${innerCardSurface}
	${tintOnHover}
	padding: 0;
	overflow: hidden;
	position: relative;
`

/** $pdf paints the app-wide red PDF badge; other non-images stay neutral grey. */
export const FileThumbnail = styled.div<{ $pdf?: boolean }>`
	width: 100%;
	aspect-ratio: 1;
	overflow: hidden;
	background: ${({ $pdf }) => ($pdf ? pdfBadgeBg : grey)};
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const FileTypeIcon = styled.div<{ $pdf?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	color: ${({ $pdf }) => ($pdf ? pdfBadgeFg : mutedGrey)};

	span {
		font-size: ${fontSizes.micro};
		font-weight: 700;
		text-transform: uppercase;
		color: ${({ $pdf }) => ($pdf ? pdfBadgeFg : textMuted)};
	}
`

export const FileInfo = styled.div`
	padding: 10px 12px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`

export const FileName = styled.div`
	font-size: ${fontSizes.caption};
	font-weight: 500;
	color: ${black};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex: 1;
	min-width: 0;
`

export const DeleteFileButton = styled(Button).attrs({ variant: 'icon' as const })`
	width: 28px;
	height: 28px;
	flex-shrink: 0;

	&:hover:not(:disabled) {
		color: ${danger};
	}
`



export const UploadOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: ${scrimDark};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: ${layers.scrim};
	gap: 16px;
	color: ${white};
	backdrop-filter: blur(2px);
`


export const UploadText = styled.div`
	font-size: ${fontSizes.title};
	font-weight: 500;
`
